var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { transient, autoinject } from "aurelia-framework";
import { Router } from "aurelia-router";
import { RouterConstants } from "../../../../configuration/router.constants";
import { WinningNominationClaimClientService } from "../../../../services/modules/winning-nomination-claim-client.service";
import { EntityTypeConfigurationHelper } from "../../../../models/basics/basics.models";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
var CreateWinningNominationClaim = /** @class */ (function () {
    function CreateWinningNominationClaim(entityTypeConfigurationHelper, notificationClientService, router, winningNominationClaimClientService) {
        this.entityTypeConfigurationHelper = entityTypeConfigurationHelper;
        this.notificationClientService = notificationClientService;
        this.router = router;
        this.winningNominationClaimClientService = winningNominationClaimClientService;
        this.entityTypes = this.entityTypeConfigurationHelper.getConfiguration([
            'TicketLineDraws'
        ]);
    }
    CreateWinningNominationClaim.prototype.goBack = function () {
        this.router.navigateBack();
    };
    CreateWinningNominationClaim.prototype.goToList = function () {
        this.router.navigateToRoute(RouterConstants.RouteNames.ListWinningNominationClaims);
    };
    CreateWinningNominationClaim.prototype.searchItemSelected = function (e) {
        var detail = e.detail;
        if (detail && detail.selectedEntityUri && detail.selectedEntity) {
            var entity = e.detail.selectedEntity;
            this.ticketDrawId = entity.gamePlayerTicketDrawId;
            this.mainPicks = entity.mainPicks;
            this.bonusPicks = entity.bonusPicks;
            this.drawDate = new Date(entity.drawDate);
        }
    };
    CreateWinningNominationClaim.prototype.save = function () {
        var _this = this;
        this.saving = true;
        this.winningNominationClaimClientService.save({
            ticketDrawId: this.ticketDrawId,
            mainPicks: this.mainPicks,
            bonusPicks: this.bonusPicks
        }).then(function (x) {
            _this.notificationClientService.show("Success", "Successfully saved ticket draw", NotificationType.Success);
            _this.saving = false;
        }, function (e) {
            _this.notificationClientService.show("Failed", "Failed to save ticket draw", NotificationType.Error);
            _this.saving = false;
        });
    };
    CreateWinningNominationClaim = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [EntityTypeConfigurationHelper, NotificationClientService,
            Router, WinningNominationClaimClientService])
    ], CreateWinningNominationClaim);
    return CreateWinningNominationClaim;
}());
export { CreateWinningNominationClaim };
